import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import BottomNav from "./BottomNav";
import RiskAcknowledgementModal from "../RiskAcknowledgementModal";

export default function Layout({ user, children }) {
  return (
    <div className="flex h-screen overflow-hidden bg-[#f2f4f8]">
      <RiskAcknowledgementModal />
      <Sidebar user={user} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar user={user} />
        <main className="flex-1 overflow-y-auto p-6 pb-20 desktop:pb-6">
          <div className="max-w-5xl mx-auto">{children}</div>
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
